import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getRowData } from '../services/allInvoiceApi';

export const fetchDocumentData = createAsyncThunk(
  'document/fetchDocumentData',
  async (documentStage) => {
    const documentData = await getRowData(documentStage);
    if (documentData) {
      return documentData;
    }
    return [];
  },
);

const documentSlice = createSlice({
  name: 'document',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocumentData.pending, (state) => ({
        ...state,
        loading: true,
        error: null,
      }))
      .addCase(fetchDocumentData.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        data: action.payload || [],
      }))
      .addCase(fetchDocumentData.rejected, (state, action) => ({
        ...state,
        loading: false,
        error: action.error.message,
      }));
  },
});

export default documentSlice.reducer;
